import React, {Component} from 'react';
const { connect } = require('react-redux');

import ProfileLink from 'components/ProfileLink';

import {t} from 'l10n';

import {formatLocation} from 'utils/user';

import '../../sass/guestbookitem.scss';

import {memberDeleteGuestbookMessage} from 'reducers/member';

import {formatDate} from 'utils/guestbookMessages';

class GuestbookItem extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        let {guestbookMessage, currentUser, memberDeleteGuestbookMessage, deleteButton = false} = this.props,
            {author} = guestbookMessage;

        let deleteFn;
        if (deleteButton || currentUser.id === author.id) {
            deleteFn = () => window.confirm(t('Do you really want to delete this message?')) && memberDeleteGuestbookMessage(guestbookMessage.id);
        }

        return (
            <div className="item-guestbook">
                <div className="top">
                    {deleteFn && <div className="delete" onClick={deleteFn}/>}
                    <div className="img">
                        <img src={author.avatar_url} alt="" />
                        {author.online ? <div className="status active"/> : <div className="status"/>}
                    </div>
                    <div className="text">
                        <ProfileLink className="name-item" user={author}/>
                        <p>{formatLocation(author)}</p>
                    </div>
                </div>
                <div className="description" dangerouslySetInnerHTML={{__html: guestbookMessage.message}}/>
                <div className="date">
                    {formatDate(guestbookMessage)}
                </div>
            </div>
        )
    }
}

export default connect(
    (state) => ({
        currentUser: state.currentUser
    }),
    {
        memberDeleteGuestbookMessage: memberDeleteGuestbookMessage
    }
)(GuestbookItem);


// WEBPACK FOOTER //
// ./src/components/guestbook/GuestbookItem.js